import styled from "@emotion/styled";
import theme from "@theme/";

const ChildContainer = styled.div`
  max-height: ${(props) => props.maxHeight || "200px"};
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  ChildContainer,
};

export default SC;
